/* eslint-disable @tanstack/query/no-deprecated-options */
export const NOTIFICATION_USER_GROUPS = [
  "Administrators",
  "Support",
  "Editor",
  "ViewerAll",
  "ViewerDashboard",
] as const;

export type NotificationUserGroup = typeof NOTIFICATION_USER_GROUPS[number];
